module.exports = __webpack_public_path__ + "static/rs-logo-header-fc2d966307a308fbda582c3994c90e55.svg";